"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OPEN_CITED_FILE_IN_WEB_LABEL = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _chat = require("../../types/chat");
var _RedlineSection = _interopRequireDefault(require("../redline/RedlineSection"));
var _branding = require("../../utils/branding");
var _actionOutcomeSave = require("../../utils/action-outcome-save");
var _redlineCardComments = require("../../utils/redline-card-comments");
var _CommentSection = _interopRequireDefault(require("../redline/CommentSection"));
var _CommentReplySection = _interopRequireDefault(require("../redline/CommentReplySection"));
var _CitationList = _interopRequireDefault(require("../common/CitationList"));
var _IcertisLoginWidget = require("@common/components/IcertisLoginWidget");
var _TemplateSelector = require("@common/components/TemplateSelector");
var _AgreementPreview = require("@common/components/AgreementPreview");
var _CollectInputCard = require("@common/components/CollectInputCard");
var _extractToolErrorMessage = require("@common/utils/extractToolErrorMessage");
var _MarkdownStreamingContext = require("@common/markdown/MarkdownStreamingContext");
var _chatMessageMarkdown = require("@common/markdown/chatMessageMarkdown");
var _chatMarkdownPipeline = require("@common/markdown/chatMarkdownPipeline");
var _tools = require("@common/constants/tools");
var _AgreementReviewForm = require("@common/components/AgreementReviewForm");
var _icertis = require("@common/schemas/icertis");
var _useIcertisAuth2 = require("../../hooks/useIcertisAuth");
var _useIcertisIntegration = require("../../hooks/useIcertisIntegration");
var _ResponseRating = require("@common/components/chat/ResponseRating");
var _GuidelineSuggestionWidget = require("@common/components/chat/GuidelineSuggestionWidget");
var _useOrgFeatureFlag = _interopRequireDefault(require("../../hooks/useOrgFeatureFlag"));
var _useDioptraFetch2 = require("../../hooks/use-dioptra-fetch");
var _envManager = require("../../utils/envManager");
var _GuidelineHistoryWidget = require("@common/components/chat/GuidelineHistoryWidget");
var _SkillSuggestionWidget = require("@common/components/SkillSuggestionWidget");
var _SkillHistoryWidget = require("@common/components/chat/SkillHistoryWidget");
var _PlaybookSelector = _interopRequireDefault(require("@common/components/chat/PlaybookSelector"));
var _PlaybookHistoryWidget = require("../common/PlaybookHistoryWidget");
var _TodoListWidget = _interopRequireDefault(require("@common/components/chat/TodoListWidget"));
var _LiveReviewWidget = _interopRequireDefault(require("./LiveReviewWidget"));
var _isStreamingJsonResult = require("@common/utils/isStreamingJsonResult");
var _liveReviewParse = require("@common/utils/liveReviewParse");
var _typedObject = require("@common/utils/typedObject");
var _ReviewReportButton = _interopRequireDefault(require("./ReviewReportButton"));
var _ToolCallGroup = _interopRequireDefault(require("@common/components/chat/ToolCallGroup"));
var _groupAssistantSteps = require("@common/components/chat/groupAssistantSteps");
var _commentToolResult = require("./comment-tool-result");
var _stripOuterMarkdownFence = require("@common/utils/stripOuterMarkdownFence");
var _zod = require("zod");
var _useProposalEngineEnabled = require("../../hooks/use-proposal-engine-enabled");
var _useResetProposalEdit = require("../../hooks/use-reset-proposal-edit");
var _ProposalEditsContext = require("../../context/ProposalEditsContext");
var _AnalyticsContext = require("../../context/AnalyticsContext");
var _CardsNotShownContext = require("../../context/CardsNotShownContext");
var _newParagraphTextCard = require("./proposal-edit/new-paragraph-text-card");
var _redlineEngine = require("@common/utils/redline/redline-engine");
var _cardKinds = require("./proposal-card/card-kinds");
var _cardContent = require("./proposal-card/card-content");
var _ProposalCardContext = require("./proposal-card/ProposalCardContext");
var _ChangeThroughoutPlaces = require("./proposal-card/ChangeThroughoutPlaces");
var _CardCommentSubcards = require("./proposal-card/CardCommentSubcards");
var _changeThroughoutSelections = require("./proposal-card/change-throughout-selections");
var _locateProposalCard = require("./proposal-card/locate-proposal-card");
var _DocumentCitationAnchor = require("./DocumentCitationAnchor");
var _workspaceDocumentHref = require("@common/utils/workspaceDocumentHref");
var _insertionLandingsContext = require("./proposal-card/insertion-landings-context");
var _MessageItem = require("./MessageItem.styles");
var _ThinkingStep = _interopRequireDefault(require("@common/components/chat/ThinkingStep"));
var _ArtifactDownloadCard = require("@common/components/chat/ArtifactDownloadCard");
var _openInBrowserWindow = require("../../utils/open-in-browser-window");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } // The `initialize_review` tool result ships its review id as JSON in the
// message content (the wire `text` field, normalized into `content` upstream).
var InitializeReviewResultSchema = _zod.z.object({
  review_id: _zod.z.string().min(1)
});
var HIDDEN_TOOL_RESULT_TOOLS = new Set(["agentic_workflow_run"]);
var OPEN_CITED_FILE_IN_WEB_LABEL = exports.OPEN_CITED_FILE_IN_WEB_LABEL = "Open in web";
var REDLINE_CARD_TOOL_NAMES = ["redline_selection", "redline_section", "edit_table", "change_throughout", "add_paragraph"];
var PROPOSED_REDLINES_TOOL_NAMES = new Set(["redline_section", "edit_table", "change_throughout"]);
function isRedlineCardTool(toolName) {
  return REDLINE_CARD_TOOL_NAMES.some(function (redlineCardToolName) {
    return redlineCardToolName === toolName;
  });
}
function cardStateOf(isApplied, isDismissed) {
  if (isApplied) return "applied";
  if (isDismissed) return "dismissed";
  return "pending";
}
function redlineSectionHeaderOf(toolName, cardNumber) {
  if (!PROPOSED_REDLINES_TOOL_NAMES.has(toolName)) return "".concat(toolName.replace(/_/g, " "), " Result");
  if (cardNumber === undefined) return "Proposed Redlines";
  return "Proposed Redlines #".concat(cardNumber);
}
function parseToolPayload(schema, content, action, toolName, sendError, index) {
  if ((0, _isStreamingJsonResult.isStreamingJsonResult)(content) || (0, _extractToolErrorMessage.extractToolErrorMessage)(content) !== undefined) return null;
  try {
    return schema.parse(JSON.parse(content));
  } catch (error) {
    sendError(error instanceof Error ? error : new Error(String(error)), {
      component: "MessageItem",
      action: action,
      messageIndex: index,
      toolName: toolName
    });
    return null;
  }
}
function IcertisAuthResult(_ref) {
  var _ref2, _effective$icm_base_u, _ref3;
  var content = _ref.content,
    sendError = _ref.sendError,
    index = _ref.index;
  var _useIcertisAuth = (0, _useIcertisAuth2.useIcertisAuth)(),
    authenticateAndReactivate = _useIcertisAuth.authenticateAndReactivate,
    isAuthenticating = _useIcertisAuth.isAuthenticating;
  var _useIcertisIntegratio = (0, _useIcertisIntegration.useIcertisIntegration)(),
    hasIntegration = _useIcertisIntegratio.hasIntegration,
    status = _useIcertisIntegratio.status,
    liveIcmBaseUrl = _useIcertisIntegratio.icmBaseUrl,
    mismatch = _useIcertisIntegratio.mismatch,
    connectedUser = _useIcertisIntegratio.connectedUser,
    refresh = _useIcertisIntegratio.refresh;
  var snapshot = parseToolPayload(_icertis.IcertisAuthSnapshotSchema, content, "parse_check_icertis_auth", "check_icertis_auth", sendError, index);
  var liveSnapshot = hasIntegration ? {
    authenticated: status === "active",
    reason: status === "expired" ? "expired" : status === "mismatch" ? "instance_mismatch" : null,
    icm_base_url: liveIcmBaseUrl !== null && liveIcmBaseUrl !== void 0 ? liveIcmBaseUrl : null,
    connected_icm_base_url: mismatch ? "https://".concat(mismatch.connectedInstanceHost) : null
  } : undefined;
  var effective = liveSnapshot !== null && liveSnapshot !== void 0 && liveSnapshot.authenticated || (liveSnapshot === null || liveSnapshot === void 0 ? void 0 : liveSnapshot.reason) === "instance_mismatch" ? liveSnapshot : snapshot !== null && snapshot !== void 0 ? snapshot : liveSnapshot;
  if (!effective) return null;
  var icmBaseUrl = (_ref2 = (_effective$icm_base_u = effective.icm_base_url) !== null && _effective$icm_base_u !== void 0 ? _effective$icm_base_u : liveIcmBaseUrl) !== null && _ref2 !== void 0 ? _ref2 : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_IcertisLoginWidget.IcertisLoginWidget, {
    authenticated: effective.authenticated,
    reauth: effective.reason === "expired" || effective.reason === "instance_mismatch",
    mismatchedIcmBaseUrl: effective.reason === "instance_mismatch" ? effective.connected_icm_base_url : null,
    icmBaseUrl: icmBaseUrl,
    connectedUser: (_ref3 = connectedUser !== null && connectedUser !== void 0 ? connectedUser : snapshot === null || snapshot === void 0 ? void 0 : snapshot.connected_user) !== null && _ref3 !== void 0 ? _ref3 : null,
    connecting: isAuthenticating,
    onConnect: function onConnect() {
      if (!icmBaseUrl) {
        throw new Error("No Icertis instance is configured for your organization.");
      }
      return authenticateAndReactivate(icmBaseUrl).then(function () {
        return refresh();
      });
    },
    "data-sentry-element": "IcertisLoginWidget",
    "data-sentry-component": "IcertisAuthResult",
    "data-sentry-source-file": "MessageItem.tsx"
  });
}
function SuggestTemplateSelectionResult(_ref4) {
  var content = _ref4.content,
    sendMessage = _ref4.sendMessage,
    sendError = _ref4.sendError,
    index = _ref4.index;
  var data = parseToolPayload(_icertis.SuggestTemplateSelectionSchema, content, "parse_template_selection", "suggest_template_selection", sendError, index);
  if (!data || !data.templates.length) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TemplateSelector.TemplateSelector, {
    templates: data.templates,
    reason: data.reason,
    sendMessage: sendMessage,
    "data-sentry-element": "TemplateSelector",
    "data-sentry-component": "SuggestTemplateSelectionResult",
    "data-sentry-source-file": "MessageItem.tsx"
  });
}
function CollectInputResult(_ref5) {
  var _message$toolName;
  var message = _ref5.message,
    conversationId = _ref5.conversationId,
    sendMessage = _ref5.sendMessage,
    sendError = _ref5.sendError,
    index = _ref5.index,
    onSave = _ref5.onSave,
    fetchLookupOptions = _ref5.fetchLookupOptions,
    selectBookmarksRangeIfPresent = _ref5.selectBookmarksRangeIfPresent,
    documentName = _ref5.documentName;
  var _useAnalytics = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics.analytics;
  var citationHost = {
    documentName: documentName,
    goToCitedParagraph: function goToCitedParagraph(citation) {
      return void (0, _locateProposalCard.goToDocumentPlace)([citation.paragraph_id], (0, _locateProposalCard.paragraphAsItReads)(citation.paragraph_id, citation.text, citation.anchor), selectBookmarksRangeIfPresent);
    },
    openCitedFile: function openCitedFile(fileId) {
      return (0, _openInBrowserWindow.openInBrowserWindow)((0, _DocumentCitationAnchor.webappDocumentUrl)((0, _workspaceDocumentHref.workspaceDocumentHref)(fileId)));
    },
    openCitedFileLabel: OPEN_CITED_FILE_IN_WEB_LABEL
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CollectInputCard.CollectInputCard, {
    messageId: message.id,
    toolName: (_message$toolName = message.toolName) !== null && _message$toolName !== void 0 ? _message$toolName : "collect_input",
    content: message.content,
    turnArtifacts: message.turnArtifacts,
    sendMessage: sendMessage,
    onSave: (/*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(messageId, toolCallId, answer) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return onSave(messageId, toolCallId, answer);
            case 1:
              if ((0, _tools.isEmailHandOffTool)(message.toolName)) analytics === null || analytics === void 0 || analytics.track("email_draft_opened", {
                conversationId: conversationId,
                messageId: messageId,
                toolCallId: toolCallId
              });
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function (_x, _x2, _x3) {
        return _ref6.apply(this, arguments);
      };
    }()),
    onEditorSidesConfirmed: function onEditorSidesConfirmed(confirmation) {
      return analytics === null || analytics === void 0 ? void 0 : analytics.track("editor_sides_confirmed", _objectSpread({
        conversationId: conversationId,
        messageId: message.id
      }, confirmation));
    },
    reportParseFailure: function reportParseFailure(error, context) {
      return sendError(error, _objectSpread(_objectSpread({}, context), {}, {
        messageIndex: index
      }));
    },
    fetchLookupOptions: fetchLookupOptions,
    citationHost: citationHost,
    "data-sentry-element": "CollectInputCard",
    "data-sentry-component": "CollectInputResult",
    "data-sentry-source-file": "MessageItem.tsx"
  });
}
function AgreementReviewFormResult(_ref7) {
  var _message$turnArtifact, _message$turnArtifact2;
  var message = _ref7.message,
    sendMessage = _ref7.sendMessage,
    sendError = _ref7.sendError,
    index = _ref7.index,
    onSave = _ref7.onSave,
    fetchLookupOptions = _ref7.fetchLookupOptions;
  var data = parseToolPayload(_icertis.RenderAgreementReviewFormSchema, message.content, "parse_agreement_review_form", "render_agreement_review_form", sendError, index);
  if (!data) return null;
  var parsedAnswer = _icertis.CollectInputAnswerSchema.safeParse((_message$turnArtifact = message.turnArtifacts) === null || _message$turnArtifact === void 0 ? void 0 : _message$turnArtifact.answer);
  if (parsedAnswer.success) {
    var answer = Object.fromEntries(Object.entries(parsedAnswer.data.values).map(function (_ref8) {
      var _ref9 = _slicedToArray(_ref8, 2),
        name = _ref9[0],
        value = _ref9[1];
      return [name, value.type === "text" ? value.value : ""];
    }));
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AgreementReviewForm.AgreementReviewForm, {
      title: data.title,
      fields: data.fields,
      reason: data.reason,
      agreements: data.agreements,
      answer: answer,
      readOnly: true
    });
  }
  var messageId = message.id;
  var toolCallId = (_message$turnArtifact2 = message.turnArtifacts) === null || _message$turnArtifact2 === void 0 ? void 0 : _message$turnArtifact2.tool_call_id;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AgreementReviewForm.AgreementReviewForm, {
    title: data.title,
    fields: data.fields,
    reason: data.reason,
    agreements: data.agreements,
    defaultView: data.default_view,
    sendMessage: sendMessage,
    fetchLookupOptions: fetchLookupOptions,
    onSubmitted: messageId && toolCallId ? function (values) {
      return onSave(messageId, toolCallId, {
        values: Object.fromEntries(Object.entries(values).map(function (_ref0) {
          var _ref1 = _slicedToArray(_ref0, 2),
            name = _ref1[0],
            value = _ref1[1];
          return [name, {
            type: "text",
            value: value
          }];
        }))
      });
    } : undefined,
    "data-sentry-element": "AgreementReviewForm",
    "data-sentry-component": "AgreementReviewFormResult",
    "data-sentry-source-file": "MessageItem.tsx"
  });
}
function AgreementPreviewResult(_ref10) {
  var content = _ref10.content,
    sendError = _ref10.sendError,
    index = _ref10.index;
  var data = parseToolPayload(_icertis.AgreementPreviewDataSchema, content, "parse_agreement_preview", "present_agreement", sendError, index);
  if (!data) return null;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AgreementPreview.AgreementPreview, {
    agreement: data,
    "data-sentry-element": "AgreementPreview",
    "data-sentry-component": "AgreementPreviewResult",
    "data-sentry-source-file": "MessageItem.tsx"
  });
}
var AddinPlaybookSelector = function AddinPlaybookSelector(props) {
  var isCreateNewEnabled = (0, _useOrgFeatureFlag.default)("is_create_old_playbook_enabled");
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookSelector.default, _objectSpread(_objectSpread({}, props), {}, {
    isCreateNewEnabled: isCreateNewEnabled,
    "data-sentry-element": "PlaybookSelector",
    "data-sentry-component": "AddinPlaybookSelector",
    "data-sentry-source-file": "MessageItem.tsx"
  }));
};
var AddinGuidelineSuggestionWidget = function AddinGuidelineSuggestionWidget(props) {
  var _useDioptraFetch = (0, _useDioptraFetch2.useDioptraFetch)(),
    dioptraFetch = _useDioptraFetch.dioptraFetch;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GuidelineSuggestionWidget.GuidelineSuggestionWidget, _objectSpread(_objectSpread({}, props), {}, {
    loadPlaybooks: function loadPlaybooks() {
      return dioptraFetch("".concat((0, _envManager.getEnv)("WEBAPP_API_BASE_URL"), "/api/playbooks"));
    },
    "data-sentry-element": "GuidelineSuggestionWidget",
    "data-sentry-component": "AddinGuidelineSuggestionWidget",
    "data-sentry-source-file": "MessageItem.tsx"
  }));
};
var MessageItem = function MessageItem(_ref11) {
  var _useProposalEngineAcc, _message$turnArtifact3, _message$turnArtifact5;
  var message = _ref11.message,
    index = _ref11.index,
    actionId = _ref11.actionId,
    citations = _ref11.citations,
    selectedConversationId = _ref11.selectedConversationId,
    documentName = _ref11.documentName,
    isActionApplied = _ref11.isActionApplied,
    isActionDismissed = _ref11.isActionDismissed,
    isActionDismissalSaving = _ref11.isActionDismissalSaving,
    markActionAsApplied = _ref11.markActionAsApplied,
    recordActionFailure = _ref11.recordActionFailure,
    markActionAsDismissed = _ref11.markActionAsDismissed,
    markActionAsUndismissed = _ref11.markActionAsUndismissed,
    getActionRecoveryWarning = _ref11.getActionRecoveryWarning,
    markActionWithRecoveryWarning = _ref11.markActionWithRecoveryWarning,
    getActionFailure = _ref11.getActionFailure,
    markActionAsFailed = _ref11.markActionAsFailed,
    cardNumber = _ref11.cardNumber,
    conflictingCards = _ref11.conflictingCards,
    supersededBy = _ref11.supersededBy,
    revertedInDocument = _ref11.revertedInDocument,
    partlyRevertedInDocument = _ref11.partlyRevertedInDocument,
    partSupersededBy = _ref11.partSupersededBy,
    potentialCollisions = _ref11.potentialCollisions,
    selectBookmarksRange = _ref11.selectBookmarksRange,
    selectBookmarksRangeIfPresent = _ref11.selectBookmarksRangeIfPresent,
    regeneratingToolResults = _ref11.regeneratingToolResults,
    regenerateMessageRedline = _ref11.regenerateMessageRedline,
    showFeedbackFormForMessageId = _ref11.showFeedbackFormForMessageId,
    setShowFeedbackFormForMessageId = _ref11.setShowFeedbackFormForMessageId,
    handleSaveGuideline = _ref11.handleSaveGuideline,
    handleDismissGuideline = _ref11.handleDismissGuideline,
    handleSaveSkill = _ref11.handleSaveSkill,
    handleDismissSkill = _ref11.handleDismissSkill,
    handlePlaybookSelect = _ref11.handlePlaybookSelect,
    handleCreateNewPlaybook = _ref11.handleCreateNewPlaybook,
    handleSaveCollectInputAnswer = _ref11.handleSaveCollectInputAnswer,
    fetchLookupOptions = _ref11.fetchLookupOptions,
    sendMessage = _ref11.sendMessage,
    handleOpenReview = _ref11.handleOpenReview,
    sendError = _ref11.sendError,
    renderMessageContent = _ref11.renderMessageContent,
    renderSentFiles = _ref11.renderSentFiles,
    handleCopyToClipboard = _ref11.handleCopyToClipboard,
    handleSaveUserMessageAsPrompt = _ref11.handleSaveUserMessageAsPrompt,
    handleDownloadMessageAsDocx = _ref11.handleDownloadMessageAsDocx,
    copyClipboardIndicator = _ref11.copyClipboardIndicator,
    savePromptIndicator = _ref11.savePromptIndicator,
    isStreaming = _ref11.isStreaming,
    isStreamingText = _ref11.isStreamingText,
    isLastMessage = _ref11.isLastMessage,
    rateable = _ref11.rateable,
    renderStepRestoreChip = _ref11.renderStepRestoreChip;
  var messageType = (0, _chat.getMessageType)(message);
  var toolName = message.toolName;
  var isAssistant = message.turnType === "assistant";
  var conversationId = selectedConversationId || "";
  var proposalEngineEnabled = (0, _useProposalEngineEnabled.useProposalEngineEnabled)();
  var _useCardsNotShown = (0, _CardsNotShownContext.useCardsNotShown)("message_item"),
    cardNotShownReasonOf = _useCardsNotShown.reasonOf;
  var assistantTextShown = isAssistant && messageType === "text" ? (0, _chatMessageMarkdown.chatMessageMarkdown)(message.content, {
    role: "assistant",
    isStreaming: isStreamingText
  }) : null;
  var _useProposalEdits = (0, _ProposalEditsContext.useProposalEdits)(),
    getProposalEdit = _useProposalEdits.getEdit,
    saveProposalEdit = _useProposalEdits.saveEdit,
    editRequestedActionId = _useProposalEdits.editRequestedActionId,
    clearEditRequest = _useProposalEdits.clearEditRequest;
  var resetProposalEdit = (0, _useResetProposalEdit.useResetProposalEdit)(conversationId);
  var proposalAuthorName = (_useProposalEngineAcc = (0, _useProposalEngineEnabled.useProposalEngineAccess)().authorName) !== null && _useProposalEngineAcc !== void 0 ? _useProposalEngineAcc : _redlineEngine.DIOPTRA_AUTHOR;
  var _useAnalytics2 = (0, _AnalyticsContext.useAnalytics)(),
    analytics = _useAnalytics2.analytics;
  var changeThroughoutSelection = (0, _changeThroughoutSelections.useChangeThroughoutSelection)(actionId, message.content);
  var redlineCardIdentity = proposalEngineEnabled ? {
    cardNumber: cardNumber,
    kind: (0, _cardKinds.cardKindReadingItsPlaces)((0, _cardKinds.proposalCardKindOf)(toolName, (0, _cardContent.textRedlineOfToolContent)(message.content)), changeThroughoutSelection !== null)
  } : null;
  var CardMessage = proposalEngineEnabled ? _MessageItem.FullWidthMessage : _MessageItem.Message;
  var proposalCardContent = proposalEngineEnabled ? (0, _cardContent.proposalCardContentOf)(toolName, message.content, message.bookmarks) : null;
  var proposalCardContext = proposalCardContent === null ? null : (0, _ProposalCardContext.proposalCardContextOf)(proposalCardContent, actionId);
  var redlineCardContext = (0, _ChangeThroughoutPlaces.cardContextWithChangeThroughoutPlaces)(proposalCardContext, changeThroughoutSelection, {
    actionId: actionId,
    cardState: cardStateOf(isActionApplied(conversationId, actionId), isActionDismissed(conversationId, actionId)),
    summaryLine: "inTheCardsFoldRow",
    conflicts: (0, _ChangeThroughoutPlaces.changeThroughoutConflictsOf)(cardNumber, potentialCollisions)
  });
  var _useContext = (0, _react.useContext)(_insertionLandingsContext.InsertionLandingsContext),
    insertionPlaceOf = _useContext.placeOf;
  var locateThisProposalCard = proposalCardContent === null ? undefined : function () {
    return (0, _locateProposalCard.locateProposalCard)(proposalCardContent, selectBookmarksRangeIfPresent, function (anchorBookmark) {
      return insertionPlaceOf(actionId, anchorBookmark);
    });
  };
  var existingProposalEdit = getProposalEdit(conversationId, actionId);
  var trackProposalEdit = function trackProposalEdit(event, cardKind) {
    analytics === null || analytics === void 0 || analytics.track(event, {
      conversationId: conversationId,
      actionId: actionId,
      cardKind: cardKind
    });
  };
  var proposalEditControlsOf = function proposalEditControlsOf(textRedlineOfCard) {
    var _redlineCardIdentity$;
    if (!proposalEngineEnabled) return null;
    var textRedlineToEdit = textRedlineOfCard !== null && textRedlineOfCard !== void 0 ? textRedlineOfCard : (proposalCardContent === null || proposalCardContent === void 0 ? void 0 : proposalCardContent.kind) === "paragraph" ? (0, _newParagraphTextCard.textCardOfNewParagraphCard)(proposalCardContent, proposalAuthorName) : null;
    if (textRedlineToEdit === null) return null;
    var textRedlineBeforeEdit = (existingProposalEdit === null || existingProposalEdit === void 0 ? void 0 : existingProposalEdit.kind) === "redline" ? existingProposalEdit.textRedlineBeforeEdit : null;
    var textRedlineWhenOpened = (existingProposalEdit === null || existingProposalEdit === void 0 ? void 0 : existingProposalEdit.kind) === "redline" ? existingProposalEdit.textRedlineWhenOpened : null;
    var cardKind = (_redlineCardIdentity$ = redlineCardIdentity === null || redlineCardIdentity === void 0 ? void 0 : redlineCardIdentity.kind) !== null && _redlineCardIdentity$ !== void 0 ? _redlineCardIdentity$ : "redline";
    return {
      textRedlineToEdit: textRedlineToEdit,
      textRedlineBeforeEdit: textRedlineBeforeEdit,
      textRedlineWhenOpened: textRedlineWhenOpened,
      editAuthor: proposalAuthorName,
      editRequested: editRequestedActionId === actionId,
      onEditRequestHandled: clearEditRequest,
      onEditOpened: function onEditOpened() {
        return trackProposalEdit("proposal_edit_opened", cardKind);
      },
      onSave: function onSave(edited, textRedlineTheBoxOpenedOn) {
        saveProposalEdit(conversationId, actionId, {
          kind: "redline",
          textRedlineBeforeEdit: textRedlineBeforeEdit !== null && textRedlineBeforeEdit !== void 0 ? textRedlineBeforeEdit : textRedlineToEdit,
          textRedline: edited,
          textRedlineWhenOpened: textRedlineTheBoxOpenedOn
        });
        trackProposalEdit("proposal_edit_saved", cardKind);
      },
      onResetToAgentVersion: function onResetToAgentVersion() {
        return resetProposalEdit(actionId, cardKind, "chat_card");
      }
    };
  };
  var commentEditControlsOf = function commentEditControlsOf(text, cardKind) {
    if (!proposalEngineEnabled) return null;
    var textBeforeEdit = (existingProposalEdit === null || existingProposalEdit === void 0 ? void 0 : existingProposalEdit.kind) === "comment" ? existingProposalEdit.textBeforeEdit : null;
    return {
      editAuthor: proposalAuthorName,
      textBeforeEdit: textBeforeEdit,
      editRequested: editRequestedActionId === actionId,
      onEditRequestHandled: clearEditRequest,
      onEditOpened: function onEditOpened() {
        return trackProposalEdit("proposal_edit_opened", cardKind);
      },
      onSave: function onSave(edited) {
        saveProposalEdit(conversationId, actionId, {
          kind: "comment",
          textBeforeEdit: textBeforeEdit !== null && textBeforeEdit !== void 0 ? textBeforeEdit : text,
          text: edited
        });
        trackProposalEdit("proposal_edit_saved", cardKind);
      },
      onResetToAgentVersion: function onResetToAgentVersion() {
        return resetProposalEdit(actionId, cardKind, "chat_card");
      }
    };
  };
  var parentToolName = typeof ((_message$turnArtifact3 = message.turnArtifacts) === null || _message$turnArtifact3 === void 0 ? void 0 : _message$turnArtifact3.parent_tool_name) === "string" ? message.turnArtifacts.parent_tool_name : undefined;

  // Memoized callbacks for CommentSection to prevent unnecessary re-renders
  var handleActionApplied = (0, _react.useCallback)(function () {
    markActionAsApplied(conversationId, actionId);
  }, [markActionAsApplied, conversationId, actionId]);
  var handleActionFailed = (0, _react.useCallback)(function (reason) {
    recordActionFailure(conversationId, actionId, reason);
  }, [recordActionFailure, conversationId, actionId]);
  var handleActionDismissed = (0, _react.useCallback)(function () {
    void (0, _actionOutcomeSave.saveActionOutcomeOrToast)(function () {
      return markActionAsDismissed(conversationId, actionId);
    });
  }, [markActionAsDismissed, conversationId, actionId]);
  var handleActionUndismissed = (0, _react.useCallback)(function () {
    void (0, _actionOutcomeSave.saveActionOutcomeOrToast)(function () {
      return markActionAsUndismissed(conversationId, actionId);
    });
  }, [markActionAsUndismissed, conversationId, actionId]);
  var handleApplyFailed = (0, _react.useCallback)(function (failure) {
    markActionAsFailed(conversationId, actionId, failure);
  }, [markActionAsFailed, conversationId, actionId]);
  var isDismissalSaving = isActionDismissalSaving(conversationId, actionId);
  if (isAssistant && toolName && HIDDEN_TOOL_RESULT_TOOLS.has(toolName)) return null;
  if (isAssistant && messageType === "thinking") {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThinkingStep.default, {
      text: message.content,
      isThinking: isStreaming && isLastMessage
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col gap-1",
    "data-turn-type": message.turnType,
    "data-parent-tool-name": parentToolName,
    "data-sentry-component": "MessageItem",
    "data-sentry-source-file": "MessageItem.tsx",
    children: [isAssistant ? (0, _chat.getMessageType)(message) === "tool_group" ? function () {
      var steps = (0, _groupAssistantSteps.toolGroupSteps)(message);
      if (steps.length === 0) return null;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToolCallGroup.default, {
        steps: steps,
        isStreaming: (0, _groupAssistantSteps.isToolGroupStreaming)(message) && isStreaming,
        compact: true,
        failedStepStyle: proposalEngineEnabled ? "neutral" : "report",
        renderStepChip: renderStepRestoreChip
      });
    }() : isRedlineCardTool(toolName) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(CardMessage, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [redlineCardIdentity === null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.SectionHeader, {
          children: redlineSectionHeaderOf(toolName, cardNumber)
        }), function () {
          try {
            var _ref12, _heldBackReasonOfSele, _getActionFailure, _getActionFailure2, _getActionFailure3;
            var toolMessageContent = JSON.parse(message.content);
            var toolMessageAfterBookmarks = toolMessageContent["after_bookmarks"];
            var toolMessageBookmarks = toolMessageContent.bookmarks || toolMessageAfterBookmarks;
            var ooxmls = (Array.isArray(toolMessageContent.ooxml) ? toolMessageContent.ooxml : [toolMessageContent.ooxml]).filter(function (entry) {
              return typeof entry === "string" && entry.length > 0;
            });
            var textRedlineOfCard = (0, _changeThroughoutSelections.textRedlineOfCardSelection)(changeThroughoutSelection, message.content);
            var cardComments = (0, _cardContent.cardCommentsOfToolContent)(message.content);
            var cardCommentSubcards = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CardCommentSubcards.CardCommentSubcards, {
              cardId: actionId,
              conversationId: conversationId,
              comments: cardComments,
              textRedline: (0, _cardContent.textRedlineOfToolContent)(message.content),
              editAuthor: proposalAuthorName,
              cardIsPending: !isActionApplied(conversationId, actionId) && !isActionDismissed(conversationId, actionId)
            });
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_RedlineSection.default, {
              ooxmls: ooxmls,
              textRedline: textRedlineOfCard,
              cardComments: cardComments,
              proposalCardComments: cardCommentSubcards,
              actionId: actionId,
              proposalEdit: proposalEditControlsOf(textRedlineOfCard),
              heldBackReasonOfTheCard: (_ref12 = (_heldBackReasonOfSele = (0, _changeThroughoutSelections.heldBackReasonOfSelection)(changeThroughoutSelection)) !== null && _heldBackReasonOfSele !== void 0 ? _heldBackReasonOfSele : cardNotShownReasonOf(actionId, _CardsNotShownContext.CARD_BUILD_SOURCE)) !== null && _ref12 !== void 0 ? _ref12 : null,
              bookmarks: toolMessageBookmarks,
              afterBookmarks: toolMessageAfterBookmarks,
              isActionApplied: isActionApplied(conversationId, actionId),
              onActionApplied: function onActionApplied() {
                return markActionAsApplied(conversationId, actionId);
              },
              onActionFailed: handleActionFailed,
              isActionDismissed: isActionDismissed(conversationId, actionId),
              isDismissalSaving: isDismissalSaving,
              onActionDismissed: handleActionDismissed,
              onActionUndismissed: handleActionUndismissed,
              recoveryWarning: getActionRecoveryWarning(conversationId, actionId),
              applyFailure: (_getActionFailure = getActionFailure(conversationId, actionId)) === null || _getActionFailure === void 0 ? void 0 : _getActionFailure.reason,
              conflictingCards: conflictingCards,
              supersededBy: supersededBy,
              revertedInDocument: revertedInDocument,
              partlyRevertedInDocument: partlyRevertedInDocument,
              partSupersededBy: partSupersededBy,
              potentialCollisions: potentialCollisions,
              proposalCard: redlineCardIdentity,
              proposalCardContext: redlineCardContext,
              proposalCardSummary: (0, _ChangeThroughoutPlaces.cardSummaryOfChangeThroughout)(changeThroughoutSelection, actionId, cardStateOf(isActionApplied(conversationId, actionId), isActionDismissed(conversationId, actionId))),
              isPartiallyApplied: (_getActionFailure2 = getActionFailure(conversationId, actionId)) === null || _getActionFailure2 === void 0 ? void 0 : _getActionFailure2.isPartiallyApplied,
              isWrittenBack: ((_getActionFailure3 = getActionFailure(conversationId, actionId)) === null || _getActionFailure3 === void 0 ? void 0 : _getActionFailure3.writtenBack) === true,
              onApplyFailed: handleApplyFailed,
              onRecoveryWarning: function onRecoveryWarning(warning) {
                return markActionWithRecoveryWarning(conversationId, actionId, warning);
              },
              onCardCommentRelocated: function onCardCommentRelocated(relocatedCardComment) {
                var relocationWarning = (0, _redlineCardComments.recoveryWarningOfRelocatedCardComment)(actionId, relocatedCardComment);
                markActionWithRecoveryWarning(conversationId, relocationWarning.actionId, relocationWarning.warning);
              },
              onGoToIssue: locateThisProposalCard !== null && locateThisProposalCard !== void 0 ? locateThisProposalCard : /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                return _regenerator().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      if (!(toolMessageBookmarks && toolMessageBookmarks.length > 0)) {
                        _context2.n = 1;
                        break;
                      }
                      _context2.n = 1;
                      return selectBookmarksRange(toolMessageBookmarks);
                    case 1:
                      return _context2.a(2);
                  }
                }, _callee2);
              })),
              isRegenerating: !!(message.id && regeneratingToolResults.has(message.id)),
              onRegenerate: function onRegenerate(feedback) {
                return regenerateMessageRedline(message, feedback);
              },
              showFeedbackForm: showFeedbackFormForMessageId === message.id,
              onToggleFeedback: function onToggleFeedback() {
                var _message$id;
                var id = (_message$id = message.id) !== null && _message$id !== void 0 ? _message$id : null;
                setShowFeedbackFormForMessageId(function (prev) {
                  return prev === id ? null : id;
                });
              }
            });
          } catch (error) {
            // Empty/partial content is the normal mid-stream state: the
            // tool_result row renders before its (large) OOXML payload has
            // streamed in. See isStreamingJsonResult.
            if ((0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontStyle: 'italic',
                  color: '#666'
                },
                children: "Loading redline result..."
              });
            } else {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: "Error parsing redline result"
              });
            }
          }
        }()]
      })
    }) : toolName === "add_comment" ? function () {
      var result = (0, _commentToolResult.parseCommentToolResult)(message.content);

      // An errored/interrupted run persists empty content — there is no
      // comment to propose, so drop the card entirely. (Mid-stream, the
      // card appears once the result content arrives.)
      if (result.kind === "empty") return null;
      if (result.kind === "modelFacingError" && proposalEngineEnabled) return null;
      var body;
      if (result.kind === "comment") {
        var _result$bookmarks, _getActionFailure4, _cardNotShownReasonOf;
        var comment = {
          text: result.text,
          author: "".concat((0, _branding.getBranding)().name, " Agent"),
          date: message.timestamp || new Date().toISOString(),
          id: message.id || "comment-".concat(Date.now()),
          bookmark_name: ((_result$bookmarks = result.bookmarks) === null || _result$bookmarks === void 0 ? void 0 : _result$bookmarks[0]) || ""
        };
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentSection.default, {
          comment: comment,
          bookmarks: result.bookmarks || message.bookmarks,
          placement: result.placement,
          anchorText: result.anchorText,
          paragraphText: result.paragraphText,
          paragraphAnchor: result.paragraphAnchor,
          isActionApplied: isActionApplied(conversationId, actionId),
          onActionApplied: handleActionApplied,
          onActionFailed: handleActionFailed,
          isActionDismissed: isActionDismissed(conversationId, actionId),
          isDismissalSaving: isDismissalSaving,
          onActionDismissed: handleActionDismissed,
          onActionUndismissed: handleActionUndismissed,
          applyFailure: (_getActionFailure4 = getActionFailure(conversationId, actionId)) === null || _getActionFailure4 === void 0 ? void 0 : _getActionFailure4.reason,
          onApplyFailed: handleApplyFailed,
          recoveryWarning: getActionRecoveryWarning(conversationId, actionId),
          onRecoveryWarning: function onRecoveryWarning(warning) {
            return markActionWithRecoveryWarning(conversationId, actionId, warning);
          },
          proposalCard: proposalEngineEnabled ? {
            cardNumber: cardNumber,
            kind: "comment"
          } : null,
          detailsActionId: actionId,
          proposalCardContext: proposalCardContext,
          commentEdit: commentEditControlsOf(result.text, "comment"),
          heldBackReasonOfTheCard: (_cardNotShownReasonOf = cardNotShownReasonOf(actionId, _CardsNotShownContext.CARD_BUILD_SOURCE)) !== null && _cardNotShownReasonOf !== void 0 ? _cardNotShownReasonOf : null,
          onGoToIssue: locateThisProposalCard
        });
      } else if (result.kind === "streaming") {
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontStyle: 'italic',
            color: '#666'
          },
          children: "Loading comment..."
        });
      } else if (result.kind === "modelFacingError") {
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontStyle: 'italic',
            color: '#666'
          },
          children: result.text
        });
      } else {
        sendError(result.error, {
          component: 'MessageItem',
          action: 'parse_comment_data',
          messageIndex: index,
          toolName: 'add_comment'
        });
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "Error parsing comment data"
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardMessage, {
        isUser: false,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [proposalEngineEnabled && result.kind === "comment" ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.SectionHeader, {
            children: "Proposed Comment"
          }), body]
        })
      });
    }() : toolName === "reply_to_comment" ? function () {
      var result = (0, _commentToolResult.parseReplyToolResult)(message.content);
      if (result.kind === "empty") return null;
      if (result.kind === "modelFacingError" && proposalEngineEnabled) return null;
      var body;
      if (result.kind === "reply") {
        var _getActionFailure5;
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)(_CommentReplySection.default, {
          reply: {
            text: result.text,
            targetCommentId: result.targetCommentId
          },
          isActionApplied: isActionApplied(conversationId, actionId),
          onActionApplied: handleActionApplied,
          onActionFailed: handleActionFailed,
          isActionDismissed: isActionDismissed(conversationId, actionId),
          isDismissalSaving: isDismissalSaving,
          onActionDismissed: handleActionDismissed,
          onActionUndismissed: handleActionUndismissed,
          applyFailure: (_getActionFailure5 = getActionFailure(conversationId, actionId)) === null || _getActionFailure5 === void 0 ? void 0 : _getActionFailure5.reason,
          onApplyFailed: handleApplyFailed,
          proposalCard: proposalEngineEnabled ? {
            cardNumber: cardNumber,
            kind: "reply"
          } : null,
          detailsActionId: actionId,
          proposalCardContext: proposalCardContext,
          commentEdit: commentEditControlsOf(result.text, "reply"),
          onGoToIssue: locateThisProposalCard
        });
      } else if (result.kind === "streaming") {
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontStyle: 'italic',
            color: '#666'
          },
          children: "Loading reply..."
        });
      } else if (result.kind === "modelFacingError") {
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontStyle: 'italic',
            color: '#666'
          },
          children: result.text
        });
      } else {
        sendError(result.error, {
          component: 'MessageItem',
          action: 'parse_reply_data',
          messageIndex: index,
          toolName: 'reply_to_comment'
        });
        body = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: "Error parsing reply data"
        });
      }
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(CardMessage, {
        isUser: false,
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [proposalEngineEnabled && result.kind === "reply" ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.SectionHeader, {
            children: "Proposed Reply"
          }), body]
        })
      });
    }() : toolName === "initialize_review" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.SectionHeader, {
          children: "Document Review"
        }), function () {
          try {
            var _InitializeReviewResu = InitializeReviewResultSchema.parse(JSON.parse(message.content)),
              review_id = _InitializeReviewResu.review_id;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ReviewReportButton.default, {
              reviewId: review_id,
              onOpen: function onOpen(rid) {
                return handleOpenReview(rid, actionId);
              }
            });
          } catch (error) {
            if ((0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                style: {
                  fontStyle: 'italic',
                  color: '#666'
                },
                children: "Starting review\u2026"
              });
            }
            sendError(error instanceof Error ? error : new Error(String(error)), {
              component: 'MessageItem',
              action: 'parse_initialize_review_result',
              messageIndex: index,
              toolName: 'initialize_review'
            });
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              children: "Error opening review"
            });
          }
        }()]
      })
    }) : toolName === "initialize_new_connection" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
        rehypePlugins: _chatMarkdownPipeline.chatRehypePlugins,
        remarkPlugins: _chatMarkdownPipeline.artifactBodyRemarkPlugins,
        children: "[Authorize Connection](".concat(message.content, ")")
      })
    }) : toolName === "check_icertis_auth" || toolName === "disconnect_icertis" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IcertisAuthResult, {
        content: message.content,
        sendError: sendError,
        index: index
      })
    }) : toolName === "suggest_template_selection" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(SuggestTemplateSelectionResult, {
        content: message.content,
        sendMessage: sendMessage,
        sendError: sendError,
        index: index
      })
    }) : (0, _tools.isCollectInputTool)(toolName) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.FullWidthMessage, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CollectInputResult, {
        message: message,
        conversationId: selectedConversationId,
        sendMessage: sendMessage,
        sendError: sendError,
        index: index,
        onSave: handleSaveCollectInputAnswer,
        fetchLookupOptions: fetchLookupOptions,
        selectBookmarksRangeIfPresent: selectBookmarksRangeIfPresent,
        documentName: documentName
      })
    }) : toolName === "render_agreement_review_form" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.FullWidthMessage, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AgreementReviewFormResult, {
        message: message,
        sendMessage: sendMessage,
        sendError: sendError,
        index: index,
        onSave: handleSaveCollectInputAnswer,
        fetchLookupOptions: fetchLookupOptions
      })
    }) : toolName === "present_agreement" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(AgreementPreviewResult, {
        content: message.content,
        sendError: sendError,
        index: index
      })
    }) : toolName === "send_guideline_suggestion" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: function () {
        var isApplied = isActionApplied(conversationId, actionId);
        var isDismissed = isActionDismissed(conversationId, actionId);
        if (!isApplied && !isDismissed) {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(AddinGuidelineSuggestionWidget, {
              data: JSON.parse(message.content),
              onLoadPlaybooksError: function onLoadPlaybooksError(loadError) {
                return sendError(loadError, {
                  component: "GuidelineSuggestionWidget",
                  action: "fetch_playbooks"
                });
              },
              onSave: function onSave(name, description, category, rule, comment, importance, playbookId) {
                return handleSaveGuideline(actionId, name, description, category, rule, comment, importance, playbookId);
              },
              onDismiss: function onDismiss() {
                return handleDismissGuideline(actionId);
              }
            });
          } catch (error) {
            sendError(error instanceof Error ? error : new Error(String(error)), {
              component: "MessageItem",
              action: "parse_guideline_suggestion",
              messageIndex: index,
              toolName: "send_guideline_suggestion"
            });
            return null;
          }
        } else {
          try {
            var guidelineData = JSON.parse(message.content);
            if (guidelineData) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GuidelineHistoryWidget.GuidelineHistoryWidget, {
                data: guidelineData
              });
            }
          } catch (error) {
            sendError(error instanceof Error ? error : new Error(String(error)), {
              component: "MessageItem",
              action: "parse_guideline_history",
              messageIndex: index,
              toolName: "send_guideline_suggestion"
            });
          }
          return null;
        }
      }()
    }) : toolName === "suggest_skill" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: function () {
        var isApplied = isActionApplied(conversationId, actionId);
        var isDismissed = isActionDismissed(conversationId, actionId);
        if (!isApplied && !isDismissed) {
          try {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkillSuggestionWidget.SkillSuggestionWidget, {
              data: JSON.parse(message.content),
              onSave: function onSave(name, description, content) {
                return handleSaveSkill(actionId, name, description, content);
              },
              onDismiss: function onDismiss() {
                return handleDismissSkill(actionId);
              }
            });
          } catch (error) {
            sendError(error instanceof Error ? error : new Error(String(error)), {
              component: "MessageItem",
              action: "parse_skill_suggestion",
              messageIndex: index,
              toolName: "suggest_skill"
            });
            return null;
          }
        } else {
          try {
            var skillData = JSON.parse(message.content);
            if (skillData) {
              return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkillHistoryWidget.SkillHistoryWidget, {
                data: _objectSpread(_objectSpread({}, skillData), {}, {
                  dismissed: isDismissed
                })
              });
            }
          } catch (error) {
            sendError(error instanceof Error ? error : new Error(String(error)), {
              component: "MessageItem",
              action: "parse_skill_history",
              messageIndex: index,
              toolName: "suggest_skill"
            });
          }
          return null;
        }
      }()
    }) : toolName === "suggest_playbook_selection" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: function () {
        try {
          var playbookData = JSON.parse(message.content);
          if (!isActionApplied(conversationId, actionId)) {
            try {
              if (playbookData.type === "playbook_suggestion") {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)(AddinPlaybookSelector, {
                  suggestedPlaybook: playbookData.suggested_playbook,
                  availablePlaybooks: playbookData.available_playbooks,
                  reason: playbookData.reason,
                  onPlaybookSelect: function onPlaybookSelect(playbook) {
                    return handlePlaybookSelect(actionId, playbook);
                  },
                  onCreateNew: function onCreateNew() {
                    return handleCreateNewPlaybook(actionId);
                  }
                });
              }
            } catch (error) {
              if ((0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) {
                return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                  style: {
                    fontStyle: 'italic',
                    color: '#666'
                  },
                  children: "Loading playbook selection..."
                });
              }
              sendError(error instanceof Error ? error : new Error(String(error)), {
                component: "MessageItem",
                action: "parse_playbook_selection_display",
                messageIndex: index,
                toolName: "suggest_playbook_selection"
              });
              return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
                children: "Error parsing playbook selection data"
              });
            }
            return null;
          } else {
            var _playbookData$suggest;
            return /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlaybookHistoryWidget.PlaybookHistoryWidget, {
              playbookName: (_playbookData$suggest = playbookData.suggested_playbook) === null || _playbookData$suggest === void 0 ? void 0 : _playbookData$suggest.name
            });
          }
        } catch (error) {
          sendError(error, {
            component: "MessageItem",
            action: "parse_playbook_selection_data",
            messageId: message.id,
            playbookData: message.content
          });
          return null;
        }
      }()
    }) : toolName === "todo_list" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: function () {
        try {
          var todoData = JSON.parse(message.content);
          return /*#__PURE__*/(0, _jsxRuntime.jsx)(_TodoListWidget.default, {
            data: todoData
          });
        } catch (error) {
          if ((0, _isStreamingJsonResult.isStreamingJsonResult)(message.content)) {
            return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
              style: {
                fontStyle: 'italic',
                color: '#666'
              },
              children: "Loading todo list..."
            });
          }
          sendError(error instanceof Error ? error : new Error(String(error)), {
            component: "MessageItem",
            action: "parse_todo_data",
            messageIndex: index,
            toolName: "todo_list"
          });
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            children: "Error parsing todo data"
          });
        }
      }()
    }) : toolName === "live_review" && messageType === "tool_result" ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: function (_message$turnArtifact4) {
        var tcid = (_message$turnArtifact4 = message.turnArtifacts) === null || _message$turnArtifact4 === void 0 ? void 0 : _message$turnArtifact4.tool_call_id;
        if (tcid && !tcid.startsWith("live_review_")) {
          return null;
        }
        var parsed = (0, _liveReviewParse.parseLiveReviewContent)(message.content);
        if (parsed.status === "streaming") {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontStyle: 'italic',
              color: '#666'
            },
            children: "Loading review..."
          });
        }
        if (parsed.status === "invalid") {
          return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            style: {
              fontStyle: 'italic',
              color: '#666'
            },
            children: "Review still processing..."
          });
        }
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_LiveReviewWidget.default, {
          data: parsed.data,
          conversationId: conversationId,
          messageId: (0, _chat.liveReviewActionScopeOf)(message)
        });
      }()
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
      isUser: false,
      children: (0, _chat.isThinking)(message) ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThinkingStep.default, {
        text: "",
        isThinking: true
      }) : assistantTextShown && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MarkdownStreamingContext.MarkdownStreamingProvider, {
          isStreaming: isStreamingText,
          children: renderMessageContent(assistantTextShown.markdown, index, citations, message)
        }), assistantTextShown.downloadLine && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArtifactDownloadCard.ArtifactDownloadCard, {
          downloadLine: assistantTextShown.downloadLine,
          onDownload: function onDownload(_ref14) {
            var url = _ref14.url;
            return (0, _openInBrowserWindow.openInBrowserWindow)(url);
          }
        }), message.citations && message.citations.length > 0 && /*#__PURE__*/(0, _jsxRuntime.jsx)(_CitationList.default, {
          citations: message.citations
        })]
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [renderSentFiles(message.turnArtifacts), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.Message, {
        isUser: true,
        children: renderMessageContent((0, _chatMessageMarkdown.chatMessageMarkdown)(message.content, {
          role: "user",
          isStreaming: false
        }).markdown, index, citations, message)
      })]
    }), !!index && isAssistant && (messageType === "text" || messageType === "tool_result") && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.MessageButtonsContainer, {
      isUser: false,
      children: messageType === "text" && !(0, _chat.isThinking)(message) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.ClipboardButton, {
          "aria-label": copyClipboardIndicator === index ? "Copied" : "Copy response",
          title: copyClipboardIndicator === index ? "Copied" : "Copy response",
          onClick: function onClick() {
            return handleCopyToClipboard(message.content, index);
          },
          children: copyClipboardIndicator === index ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
            width: 16,
            height: 16,
            color: "#4a5568"
          }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.ContentCopyIcon, {
            width: 16,
            height: 16,
            color: "#4a5568"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.ClipboardButton, {
          title: "Download as DOCX",
          onClick: /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
            var messageContent;
            return _regenerator().w(function (_context3) {
              while (1) switch (_context3.n) {
                case 0:
                  messageContent = (0, _stripOuterMarkdownFence.stripOuterMarkdownFence)(message.content);
                  _context3.n = 1;
                  return handleDownloadMessageAsDocx(messageContent);
                case 1:
                  return _context3.a(2);
              }
            }, _callee3);
          })),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.DownloadIcon, {
            width: 16,
            height: 16,
            color: "#4a5568"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResponseRating.ResponseRatingSlot, {
          conversationId: conversationId,
          turnId: message.id,
          value: (_message$turnArtifact5 = message.turnArtifacts) === null || _message$turnArtifact5 === void 0 ? void 0 : _message$turnArtifact5.user_feedback,
          rateable: rateable
        })]
      })
    }), !!index && !isAssistant && messageType === "text" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.MessageButtonsContainer, {
      isUser: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MessageItem.ClipboardButton, {
        title: "Save as prompt",
        onClick: function onClick() {
          return handleSaveUserMessageAsPrompt(message.content, index);
        },
        children: savePromptIndicator === index ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.CheckIcon, {
          width: 16,
          height: 16,
          color: "#4a5568"
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.BookmarkIcon, {
          width: 16,
          height: 16,
          color: "#4a5568"
        })
      })
    })]
  });
};
var areMessageItemPropsEqual = function areMessageItemPropsEqual(prevProps, nextProps) {
  var _prevProps$message$tu, _nextProps$message$tu;
  var turnArtifactsEqual = function turnArtifactsEqual(prev, next) {
    if (!prev && !next) {
      return true;
    }
    if (!prev || !next) {
      return false;
    }
    if (prev.tool_call_id !== next.tool_call_id) {
      return false;
    }
    var prevKeys = _typedObject.TypedObject.keys(prev);
    var nextKeys = _typedObject.TypedObject.keys(next);
    if (prevKeys.length !== nextKeys.length) {
      return false;
    }
    return prevKeys.every(function (key) {
      return prev[key] === next[key];
    });
  };
  if (prevProps.message.id !== nextProps.message.id || prevProps.message.content !== nextProps.message.content || prevProps.message.turnType !== nextProps.message.turnType || prevProps.message.toolName !== nextProps.message.toolName || prevProps.message.timestamp !== nextProps.message.timestamp || Boolean((_prevProps$message$tu = prevProps.message.turnArtifacts) === null || _prevProps$message$tu === void 0 ? void 0 : _prevProps$message$tu.answer) !== Boolean((_nextProps$message$tu = nextProps.message.turnArtifacts) === null || _nextProps$message$tu === void 0 ? void 0 : _nextProps$message$tu.answer) || prevProps.index !== nextProps.index || prevProps.isStreamingText !== nextProps.isStreamingText || prevProps.actionId !== nextProps.actionId || prevProps.selectedConversationId !== nextProps.selectedConversationId || prevProps.documentName !== nextProps.documentName || prevProps.showFeedbackFormForMessageId !== nextProps.showFeedbackFormForMessageId || prevProps.copyClipboardIndicator !== nextProps.copyClipboardIndicator || prevProps.savePromptIndicator !== nextProps.savePromptIndicator || prevProps.isStreaming !== nextProps.isStreaming || prevProps.isLastMessage !== nextProps.isLastMessage || prevProps.rateable !== nextProps.rateable || prevProps.renderStepRestoreChip !== nextProps.renderStepRestoreChip) {
    return false;
  }
  var prevConversationId = prevProps.selectedConversationId || "";
  var nextConversationId = nextProps.selectedConversationId || "";
  if (prevProps.isActionApplied(prevConversationId, prevProps.actionId) !== nextProps.isActionApplied(nextConversationId, nextProps.actionId) || prevProps.isActionDismissed(prevConversationId, prevProps.actionId) !== nextProps.isActionDismissed(nextConversationId, nextProps.actionId) || prevProps.isActionDismissalSaving(prevConversationId, prevProps.actionId) !== nextProps.isActionDismissalSaving(nextConversationId, nextProps.actionId) || prevProps.getActionRecoveryWarning(prevConversationId, prevProps.actionId) !== nextProps.getActionRecoveryWarning(nextConversationId, nextProps.actionId) || prevProps.getActionFailure(prevConversationId, prevProps.actionId) !== nextProps.getActionFailure(nextConversationId, nextProps.actionId) || prevProps.cardNumber !== nextProps.cardNumber || prevProps.conflictingCards.map(function (card) {
    return "".concat(card.id, ":").concat(card.label);
  }).join(",") !== nextProps.conflictingCards.map(function (card) {
    return "".concat(card.id, ":").concat(card.label);
  }).join(",") || prevProps.supersededBy !== nextProps.supersededBy || prevProps.revertedInDocument !== nextProps.revertedInDocument || prevProps.partlyRevertedInDocument !== nextProps.partlyRevertedInDocument || prevProps.partSupersededBy !== nextProps.partSupersededBy || prevProps.potentialCollisions.map(function (collision) {
    return "".concat(collision.number, ":").concat(collision.proximity, ":").concat(collision.alsoMakesSameChange);
  }).join(",") !== nextProps.potentialCollisions.map(function (collision) {
    return "".concat(collision.number, ":").concat(collision.proximity, ":").concat(collision.alsoMakesSameChange);
  }).join(",")) {
    return false;
  }
  var prevIsRegenerating = !!(prevProps.message.id && prevProps.regeneratingToolResults.has(prevProps.message.id));
  var nextIsRegenerating = !!(nextProps.message.id && nextProps.regeneratingToolResults.has(nextProps.message.id));
  if (prevIsRegenerating !== nextIsRegenerating) {
    return false;
  }
  if (prevProps.citations.length !== nextProps.citations.length) {
    return false;
  }
  for (var i = 0; i < prevProps.citations.length; i++) {
    if (prevProps.citations[i].id !== nextProps.citations[i].id) {
      return false;
    }
  }
  var prevMessageCitations = prevProps.message.citations || [];
  var nextMessageCitations = nextProps.message.citations || [];
  if (prevMessageCitations.length !== nextMessageCitations.length) {
    return false;
  }
  for (var _i = 0; _i < prevMessageCitations.length; _i++) {
    if (prevMessageCitations[_i].id !== nextMessageCitations[_i].id) {
      return false;
    }
  }
  var prevTurnArtifacts = prevProps.message.turnArtifacts;
  var nextTurnArtifacts = nextProps.message.turnArtifacts;
  if (!turnArtifactsEqual(prevTurnArtifacts, nextTurnArtifacts)) {
    return false;
  }
  return true;
};
var _default = exports.default = /*#__PURE__*/_react.default.memo(MessageItem, areMessageItemPropsEqual);